import { createFileRoute } from '@tanstack/react-router';
import { parseHeatmapSearch } from '@/features/resources/heatmap/heatmap-search';
import { RoleHeatmap } from '@/features/resources/heatmap/role-heatmap';

/** Job roles × weeks: demand vs. capacity (RES-06). */
export const Route = createFileRoute('/_app/resources/roles')({
  validateSearch: (raw: Record<string, unknown>) => parseHeatmapSearch(raw),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RoleHeatmap
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: next, replace: true });
      }}
    />
  );
}
